var SortingDirection = /* @__PURE__ */ ((SortingDirection2) => {
  SortingDirection2["ASC"] = "asc";
  SortingDirection2["DESC"] = "desc";
  return SortingDirection2;
})(SortingDirection || {});
var Category = /* @__PURE__ */ ((Category2) => {
  Category2["APPOINTMENT_HANDLING"] = "APPOINTMENT_HANDLING";
  Category2["BILLING"] = "BILLING";
  Category2["CALL_COLLEAGUE"] = "CALL_COLLEAGUE";
  Category2["CALL_PATIENT"] = "CALL_PATIENT";
  Category2["COST_PLAN"] = "COST_PLAN";
  Category2["DOCUMENTATION"] = "DOCUMENTATION";
  Category2["FOLLOWUP_APPOINTMENT"] = "FOLLOWUP_APPOINTMENT";
  Category2["INFORMATION"] = "INFORMATION";
  Category2["INSURANCE"] = "INSURANCE";
  Category2["MEETING"] = "MEETING";
  Category2["OTHER"] = "OTHER";
  Category2["PAIN_PATIENT"] = "PAIN_PATIENT";
  Category2["PATIENTS_INFORMATION"] = "PATIENTS_INFORMATION";
  Category2["POST_SENDOUT"] = "POST_SENDOUT";
  Category2["PROBLEM_SOLVING"] = "PROBLEM_SOLVING";
  Category2["RECALL"] = "RECALL";
  Category2["REFER_PATIENT"] = "REFER_PATIENT";
  Category2["SHIFT_PLANNING"] = "SHIFT_PLANNING";
  Category2["TREATMENT_INFORMATION"] = "TREATMENT_INFORMATION";
  Category2["OPEN_HKP"] = "OPEN_HKP";
  return Category2;
})(Category || {});
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["TO_DO"] = "TO_DO";
  Status2["IN_PROGRESS"] = "IN_PROGRESS";
  Status2["DONE"] = "DONE";
  Status2["IGNORED"] = "IGNORED";
  Status2["RECALLED"] = "RECALLED";
  return Status2;
})(Status || {});
var Origin = /* @__PURE__ */ ((Origin2) => {
  Origin2["MANUAL"] = "MANUAL";
  Origin2["AUTO_ONLINE_CANCELLATION"] = "AUTO_ONLINE_CANCELLATION";
  Origin2["AUTO_HKP_FOLLOWUP"] = "AUTO_HKP_FOLLOWUP";
  Origin2["AUTO_ACCEPTED_HKP_NO_FOLLOWUP"] = "AUTO_ACCEPTED_HKP_NO_FOLLOWUP";
  return Origin2;
})(Origin || {});
var ServerSentResourceType = /* @__PURE__ */ ((ServerSentResourceType2) => {
  ServerSentResourceType2["ANAMNESIS"] = "ANAMNESIS";
  ServerSentResourceType2["APPOINTMENT"] = "APPOINTMENT";
  ServerSentResourceType2["CALL_TASK"] = "CALL_TASK";
  ServerSentResourceType2["TEXT_MESSAGE"] = "TEXT_MESSAGE";
  ServerSentResourceType2["CONVERSATION"] = "CONVERSATION";
  ServerSentResourceType2["TASK"] = "TASK";
  ServerSentResourceType2["TODO_LIST_TASK"] = "TODO_LIST_TASK";
  ServerSentResourceType2["PATIENT"] = "PATIENT";
  ServerSentResourceType2["OPEN_APPOINTMENT"] = "OPEN_APPOINTMENT";
  ServerSentResourceType2["PATIENT_CREDITWORTHINESS"] = "PATIENT_CREDITWORTHINESS";
  return ServerSentResourceType2;
})(ServerSentResourceType || {});
export {
  Category,
  Origin,
  ServerSentResourceType,
  SortingDirection,
  Status
};
